import React from 'react';
import { Text } from 'components/typography/Text';
import { CheckMarkIcon } from 'assets/icons/CheckMarkIcon';
import { ShouldRender } from 'components/ShouldRender';
import { useAccessManagement2NModal } from '../../../AccessManagement2NModalContext/useAccessManagement2NModal';
import styles from './styles.module.scss';

export const TimeProfile = ({ timeProfile }) => {

  const { selected, updateSelected, updateAdding } = useAccessManagement2NModal();
  const selectedTimeProfile = selected.timeProfile;
  const timeProfileId = timeProfile && (timeProfile.Id || timeProfile.id);
  const selectedTimeProfileId = selectedTimeProfile && (selectedTimeProfile.Id || selectedTimeProfile.id);
  const timeProfileName = (timeProfile && (timeProfile.Name || timeProfile.name)) || '';

  const onTimeProfileClick = () => {
    updateSelected('timeProfile', timeProfile);
    updateAdding('timeProfile', false);
  };

  return (
    <div
      className={styles.timeProfileCard}
      onClick={onTimeProfileClick}
    >
      <div className={styles.details}>
        {/*<div className={styles.icon}>*/}
        {/*  {group.icon}*/}
        {/*</div>*/}
        <Text
          size={14}
          uppercase
        >
          {timeProfileName}
        </Text>
      </div>

      <ShouldRender condition={!!selectedTimeProfile && selectedTimeProfileId === timeProfileId}>
        <CheckMarkIcon
          active
        />
      </ShouldRender>
    </div>
  );
};

